import { ModalsEnum } from '../../enums';

import HighlightModal from './highlight-modal';

const modalsList = [
  { component: HighlightModal, name: ModalsEnum.HIGHLIGHT },
] as const;

export default modalsList;
